import { render, staticRenderFns } from "./AssignAnalysts.vue?vue&type=template&id=2bf9977c&scoped=true"
import script from "./AssignAnalysts.vue?vue&type=script&lang=js"
export * from "./AssignAnalysts.vue?vue&type=script&lang=js"
import style0 from "./AssignAnalysts.vue?vue&type=style&index=0&id=2bf9977c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf9977c",
  null
  
)

export default component.exports